/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ToolInventoryHistory } from '../models/ToolInventoryHistory';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ToolInventoryHistoryService {
    /**
     * show inventory
     * @param toolId
     * @returns ToolInventoryHistory successful
     * @throws ApiError
     */
    public static getInventoryHistory(
        toolId: string,
    ): CancelablePromise<ToolInventoryHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/inventory_history/{tool_id}',
            path: {
                'tool_id': toolId,
            },
        });
    }
}
